import { render, staticRenderFns } from "./SForm.vue?vue&type=template&id=4458ea02&scoped=true&"
import script from "./SForm.vue?vue&type=script&lang=ts&"
export * from "./SForm.vue?vue&type=script&lang=ts&"
import style0 from "./SForm.vue?vue&type=style&index=0&id=4458ea02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4458ea02",
  null
  
)

export default component.exports